<div class="profile-nav-mobile-container">
  <img [src]="profileHeaderImage">

  <span class="scan-btn" (click)="showScannerDialog()"><i class="icon-scan"></i></span>

  <div class="profile-nav-mobile-content">
    <div class="userInfo">
      <ng-template [ngIf]="isLoggedIn">
        <div class="userDetails" (click)="onNavigate('editProfile')">
          <h1 class="userName truncateText">{{name}}</h1>
          <h1>{{phoneNumber}}</h1>
        </div>

        <div class="userQR-container" *ngIf="customerNo">
          <app-barcode-qrcode [qrCodeValue]="customerNo" [showBothCodesInPopup]="true" [isShowDesc]="false"
            [QrHeight]="'80px'" [QrWidth]="'80px'"></app-barcode-qrcode>
        </div>
      </ng-template>

      <ng-template [ngIf]="!isLoggedIn">
        <div class="guest-login-container" (click)="displayLogin = true">
          <div class="guestLogin-desc">
            <h1 class="guestLogin-title">{{'desc.hi.guest' | translate}}</h1>
            <h1>{{'desc.let.unlock.exlusive.perks' | translate}}</h1>
          </div>

          <div class="action-container">
            <app-button [shineButton]="true" [buttonName]="'button.login.get.perks' | translate"></app-button>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="menuListing">
      <div class="menu-content" *ngIf="isLoggedIn" (click)="onNavigate('MngAddr')">
        <span>{{'menu.manage.address' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

      <div class="menu-content" *ngIf="isLoggedIn" (click)="onNavigate('fav')">
        <span>{{'menu.my.fav' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

      <div class="menu-content" *ngIf="isLoggedIn" (click)="onNavigate('paymentMtd')">
        <span>{{'menu.payment.methods' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

      <div class="menu-content" (click)="onNavigate('setupPw')" *ngIf="isLoggedIn === true && !passwordFlag">
        <span>{{'setup.password.title' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

      <div class="menu-content" (click)="onNavigate('changePw')" *ngIf="isLoggedIn === true && passwordFlag">
        <span>{{'menu.change.password' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

      <div class="menu-content menu-content-settings" (click)="onNavigate('setting')">
        <span>{{'menu.settings' | translate}}</span>
        <i class="icon-chevron-right"></i>
      </div>

    </div>
  </div>

  <div class="profile-footer">
    <app-button [textButton]="true" [buttonName]="'button.logout'" class="logout-btn" (click)="onLogout()"
      *ngIf="isLoggedIn"></app-button>
    <span class="version">{{'build.version' | translate: {version: buildVersion} }}</span>
  </div>
</div>

<p-dialog [position]="dialogPosition" [(visible)]="displayLogin" [baseZIndex]="999999999999" *ngIf="displayLogin"
  [modal]="true" [dismissableMask]="false" [blockScroll]="true"
  [styleClass]="isDialogCenter ? 'centerScreen-dialog' : 'isDisplayWhatsappLogin-dialog'">
  <app-whatsapp-authentication (onClickClose)="displayLogin = false" (onMobileNoLogin)="onLogin()"
    [whatsappEnquiryParam]="'profile'" (onShowFail)="onWhatsappFail($event)"
    (onSuccessClose)="displayLogin = false;"></app-whatsapp-authentication>
</p-dialog>